var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authorized&&_vm.authInited)?[_vm._t("default")]:(!_vm.authInited)?_c('span',[_vm._v("认证中...")]):_c('page401')],2)}
var staticRenderFns = []

export { render, staticRenderFns }